import { collaborationApi } from "@/shared/services/collaboration";
import { useCallback } from "react";

// Returns a fetcher that mints a short-lived JWT for the given Yjs room. Passed
// to HocuspocusProvider as `token: () => fetcher(roomId)` so it re-mints on
// reconnect rather than caching a stale token.
export const useHocuspocusToken = () => {
  return useCallback(async (room: string): Promise<string> => {
    const { token } = await collaborationApi.hocuspocusToken({ room });
    return token;
  }, []);
};
